import { yupResolver } from "@hookform/resolvers/yup";
import { useDisclosure } from "@nextui-org/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { deleteFetcher, getFetcher, patchFetcher, postFetcher } from "../../services/api";
import { isResponseErrorObject } from "../../services/helpers";
import useSWR from "swr";
import { pelabuhanBongkarValidation } from "../../services/validation/pelabuhan-bongkar.validation";

export default function usePelabuhanBongkar() {
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const {isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm} = useDisclosure();
    const {isOpen: isOpenModalAlert, onOpenChange: onOpenChangeModalAlert} = useDisclosure();
    const [editId, setEditId] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const { handleSubmit,  reset, watch, control, formState: { isSubmitting, dirtyFields }} = useForm({ resolver: yupResolver(pelabuhanBongkarValidation) });
    const { data, isLoading, mutate } = useSWR(`/api/data-pelabuhan/search?page=${page+1}&limit=${pageSize}`, getFetcher);

    function onClickEdit(item) {    
        setEditId(item.id);
        setIsEdit(true);
        reset({
            id_lokasi: item.id_lokasi,
            kd_kantor: item.kd_kantor,
            nm_lokasi: item.nm_lokasi,
            nm_kantor_pendek: item.nm_kantor_pendek,
            latitude: item.latitude,
            longitude: item.longitude
        });           
        onOpenChangeModalForm();
    }

    function onCloseForm() {
        setEditId(null);
        setIsEdit(false);
        reset({
            id_lokasi: '',
            kd_kantor: '',
            nm_lokasi: '',
            nm_kantor_pendek: '',
            latitude: '',
            longitude: ''
        });
        onCloseModalForm()
    }

    function onClickDelete(id) {
        setEditId(id);
        onOpenChangeModalAlert();
    }
    
    async function onSubmitDelete() {
        try {
            await deleteFetcher('/api/data-pelabuhan', editId);
            mutate()
            toast.success('Pelabuhan bongkar berhasil dihapus!');
        } catch (error) {
            toast.error('Gagal hapus pelabuhan bongkar!');
        }
    }

    async function onSubmitForm(formData) {
        try {
            if (isEdit) {
                await patchFetcher(`/api/data-pelabuhan`, editId, formData);
                mutate()
                toast.success('Pelabuhan bongkar berhasil diubah!');
            } else {
                await postFetcher(`/api/data-pelabuhan`, formData);
                mutate()
                toast.success('Pelabuhan bongkar berhasil ditambah!');
            }
            onCloseForm();
        } catch (error) {
            isResponseErrorObject(error.response.data.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value);
                })
                : toast.error(error.response.data.message)
        }
    }

    return {
        modalForm: {
            isOpenModalForm,
            onOpenModalForm,
            onOpenChangeModalForm,
        },
        modalAlert: {
            isOpenModalAlert,
            onOpenChangeModalAlert,
        },
        hookForm: {
            handleSubmit, 
            reset, 
            watch,
            control,
            formState: { isSubmitting, dirtyFields }
        },
        dataFetch: {
            data,
            isLoading,
        },
        isEdit,
        page,
        pageSize,
        setPage,
        setPageSize,
        onClickEdit,
        onCloseForm,
        onClickDelete,
        onSubmitDelete,
        onSubmitForm,
    }
}